import { useContext, useEffect } from "react";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import { AIChatV3, useAIChatStoreV3 } from "../stores/aiChatStoreV3";
import { ChatMessageV3, SearchResultV3 } from "../types/aiChatClientV3";

export interface UseAIChatV3ReturnType {
  messages: ChatMessageV3[];
  isLoading: boolean;
  isSearching: boolean;
  error: string | null;
  sendMessage: (prompt: string) => Promise<void>;
  currentSearchResult: SearchResultV3 | null;
  clearError: () => void;
  clearHistoryMessagesToSend: () => void;
  internalCADViewerAICallback: (chatMessage: ChatMessageV3) => void;
  currentHighlight: string | null;
  clearCurrentHighlight: () => void;
}

export function useAIChatV3(): UseAIChatV3ReturnType {
  const { plansInfo, distanceData, selectedPlan, selectedPlanDetail } = useContext(CadviewerContext);
  //console.log({ plansInfo, distanceData });
  const spacesNames =
    plansInfo?.spaces.map((space) => ({
      name: space.spaceHeader,
      dbas: [], // space.detailTabs.map((tab) => tab.detail.DBA),
    })) || [];

  // Utiliser directement les propriétés du store avec destructuring
  const messages = useAIChatStoreV3((state: AIChatV3) => state.messages);
  const isLoading = useAIChatStoreV3((state: AIChatV3) => state.isLoading);
  const isSearching = useAIChatStoreV3((state: AIChatV3) => state.isSearching);
  const error = useAIChatStoreV3((state: AIChatV3) => state.error);
  const currentSearchResult = useAIChatStoreV3(
    (state: AIChatV3) => state.currentSearchResult
  );
  const currentHighlight = useAIChatStoreV3(
    (state: AIChatV3) => state.currentHighlight
  );
  const clearCurrentHighlight = useAIChatStoreV3(
    (state: AIChatV3) => state.clearCurrentHighlight
  );
  const sendMessage = useAIChatStoreV3((state: AIChatV3) => state.sendMessage);
  const mockSendMessage = async (
    prompt: string,
    useGlobalMode: boolean = false,
    selectedSpaces?: string[]
  ) => {
    await sendMessage(
      prompt,
      spacesNames,
      selectedPlan,
      selectedPlanDetail,
      useGlobalMode,
      selectedSpaces
    );
  };
  const clearError = useAIChatStoreV3((state: AIChatV3) => state.clearError);
  const clearHistoryMessagesToSend = useAIChatStoreV3(
    (state: AIChatV3) => state.clearHistoryMessagesToSend
  );
  const internalCADViewerAICallback = useAIChatStoreV3(
    (state: AIChatV3) => state.internalCADViewerAICallback
  );
  const setPlansInfoAndDistanceData = useAIChatStoreV3(
    (state: AIChatV3) => state.setPlansInfoAndDistanceData
  );

  // Synchroniser les données du context avec le store
  useEffect(() => {
    setPlansInfoAndDistanceData(plansInfo, distanceData);
  }, [plansInfo, distanceData, setPlansInfoAndDistanceData]);

  return {
    messages,
    isLoading,
    isSearching,
    error,
    sendMessage: mockSendMessage,
    currentSearchResult,
    clearError,
    clearHistoryMessagesToSend,
    internalCADViewerAICallback,
    currentHighlight,
    clearCurrentHighlight,
  };
}
